import { COOKS_DOC, COOKS_MAP_KEY, type CookLogEntry } from '@awwyeah/shared';
import { useYDoc, useYMap } from '../../sync';

/**
 * Read-only view of the family cook log (`COOKS_DOC`) for the check-in feed's merge (owner
 * ask 2026-08-18: "a 'Cooked this' thing … that also adds to the timeline"). Duplicated
 * rather than imported from `apps/web/src/modules/recipes/cooks.ts` — feature modules don't
 * reach into each other's internals (docs/ARCHITECTURE.md), exactly as `./games.ts` does for
 * the games registry.
 *
 * This module only ever *reads* `COOKS_DOC`. Logging a cook belongs to the recipes module,
 * where the recipe you cooked is in front of you; the feed's job is only to show it where it
 * belongs in time.
 */
export function useCooksForFeed(): CookLogEntry[] {
  const doc = useYDoc(COOKS_DOC);
  const { entries } = useYMap<CookLogEntry>(doc, COOKS_MAP_KEY);
  return entries.map(([, cook]) => cook).filter(Boolean);
}
